// --- utils/address.js ---
export const buildFullAddress = ({ address1, address2, postalCode, city, country = "France" }) =>
    [address1, address2, `${postalCode} ${city}`, country].filter(Boolean).join(", ");
  
  export const parseAddressComponents = (components = []) => {
    const byType = (t) => components.find(c => c.types.includes(t))?.long_name || "";
    const streetNumber = byType("street_number");
    const route = byType("route");
    const address1 = [streetNumber, route].filter(Boolean).join(" ");
    const postalCode = byType("postal_code");
    const city =
      byType("locality") || byType("postal_town") || byType("administrative_area_level_2") || "";
    const country = byType("country") || "France";
    return { address1, postalCode, city, country };
  };
  
  export const toNiceCase = (s = "") =>
    s.toLowerCase().replace(/\b\p{L}/gu, (m) => m.toUpperCase());
  
  export const normalizeCity = (city = "") => {
    // Enlève le CP placé au début, ex "84260 SARRIANS" → "Sarrians"
    const trimmed = city.trim();
    const withoutCP = trimmed.replace(/^\s*\d{5}\s+/, "");
    return toNiceCase(withoutCP);
  };
  
  export const haversineMeters = (a, b) => {
    if (!a || !b) return Infinity;
    const R = 6371000;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);
    const x =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(x));
  };
  